<div class="flex flex-row justify-center items-center">
	<h1 class="pt-200">{{'TENANT_DETAILS.COMING_SOON' | transloco}}</h1>
</div>
